import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "antd-mobile";
import { FaBarcode, FaTimes } from "react-icons/fa";
import styled from "styled-components";
import * as _ from "underscore";
import { FormattedMessage, injectIntl } from "react-intl";
import Color from "../../utils/Color";
import Theme from "../../utils/Theme";

const ServiceOptionsContainer = styled.div`
  width: 100%;
  display: block;
  background: white;
  border: 1px solid lightgray;
  box-shadow: 0 4px 6px -5px grey;
`;

const ServiceOptionsContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const ServiceOptionsTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: start;
  align-self: stretch;
  font-size: 1em;
  padding: 10px 15px;
  color: ${Color.favouriteColor};
  border-bottom: 1px solid lightgrey;
`;

const StyledTitle = styled.div`
  width: 50%;
`;

const StyledCloseButton = styled.div`
  cursor: pointer;
  width: 50%;
  text-align: right;
`;

const ServiceTableContainer = styled.div`
  align-self: stretch;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 15px;
`;

const ServiceTableInputContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const ServiceTableInput = styled.div`
  width: 55%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 5px;
  background: white;
  border: 1px solid
    ${props => (props.confirm ? Color.confirmedColor : "lightgrey")};
  color: ${props => (props.confirm ? Color.confirmedColor : "black")};
  box-shadow: none;
  outline: none;
`;

const StyledScanQrButton = styled.div`
  cursor: pointer;
  margin-left: 8px;
  border-radius: 50%;
  background: ${Theme.PrimaryColor};
  color: white;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSubmitButton = styled.div`
  cursor: pointer;
  margin-left: 8px;
  background: ${Color.Tertiary};
  color: white;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class ChangeTableModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tableNo: null
    };
  }

  componentDidMount() {
    const { currentTable } = this.props;

    this.setState({
      tableNo: currentTable
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.currentTable !== this.props.currentTable) {
      this.setState({
        tableNo: nextProps.currentTable
      });
    }
  }

  onTableValueChanged = value => {
    this.setState({
      tableNo: value
    });
  };

  onTableNoSubmit = () => {
    const { onTableValueSubmit } = this.props;
    const { tableNo } = this.state;
    onTableValueSubmit && onTableValueSubmit(tableNo);
  };

  onClose = () => {
    const { onClose } = this.props;

    onClose && onClose();
  };

  render() {
    const { tableNo } = this.state;
    const {
      history,
      shouldShow,
      currentTable,
      intl,
      onTouchStart,
      orderID
    } = this.props;
    return (
      <Modal
        className={"filter-modal"}
        visible={shouldShow}
        transparent
        maskClosable={false}
        onClose={() => this.onClose()}
        wrapProps={{ onTouchStart: onTouchStart }}
      >
        <ServiceOptionsContainer>
          <ServiceOptionsContent>
            <ServiceOptionsTitle>
              <StyledTitle>
                <FormattedMessage
                  id="cart.service.options.title"
                  defaultMessage="How'd you want to get your food?"
                  description="Cart Service Options Title"
                />
              </StyledTitle>
              <StyledCloseButton>
                <FaTimes onClick={() => this.onClose()} />
              </StyledCloseButton>
            </ServiceOptionsTitle>
            <ServiceTableContainer>
              <FormattedMessage
                id="cart.service.options.delivery.table.title"
                defaultMessage="Your table no."
                description="Cart Service Delivery Table Title"
              />
              <ServiceTableInputContainer>
                <ServiceTableInput>
                  <StyledInput
                    confirm={
                      !_.isEmpty(currentTable) && currentTable === tableNo
                    }
                    value={tableNo}
                    onChange={v => this.onTableValueChanged(v.target.value)}
                    placeholder={intl.formatMessage({
                      id: "cart.service.options.delivery.table.placeholder",
                      defaultMessage: "table no",
                      description: "Cart Service Delivery Table Placeholder"
                    })}
                  />
                </ServiceTableInput>
                <StyledSubmitButton
                  className="opacity"
                  onClick={() => this.onTableNoSubmit()}
                >
                  Submit
                </StyledSubmitButton>
                <span style={{ marginLeft: "8px" }}>
                  <FormattedMessage id={"app.or"} />
                </span>
                <StyledScanQrButton
                  className={"opacity"}
                  onClick={() =>
                    history.push({
                      pathname: "/shop/scanner",
                      state: { returnUrl: `/shop/order/${orderID}` }
                    })
                  }
                >
                  <FaBarcode size={"1em"} />
                </StyledScanQrButton>
              </ServiceTableInputContainer>
            </ServiceTableContainer>
          </ServiceOptionsContent>
        </ServiceOptionsContainer>
      </Modal>
    );
  }
}

ChangeTableModal.propsType = {
  intl: PropTypes.object,
  history: PropTypes.object.isRequired,
  shouldShow: PropTypes.object.isRequired,
  onTableValueSubmit: PropTypes.func.isRequired,
  currentTable: PropTypes.string
};

ChangeTableModal.defaultProps = {
  ChangeTableModal: false
};

export default injectIntl(ChangeTableModal);



// WEBPACK FOOTER //
// ./src/containers/ChangeTableModal/index.js